import React from "react";
import { Link } from "react-router-dom";
import logo from "../../images/rg_logo-2.webp";

const e = React.createElement;

const socialPlatforms = [
  { platform: 'instagram', href: 'https://www.instagram.com/rent.gurus/' },
  { platform: 'facebook', href: 'https://www.facebook.com/profile.php?id=61591878274955' },
  { platform: 'twitter', href: 'https://x.com/rentguruspromo' },
  { platform: 'linkedin', href: 'https://www.linkedin.com/company/rentgurus' },
];

function SocialIcon({ platform }) {
  if (platform === 'facebook') {
    return e('svg', { className: 'w-4 h-4 fill-current', viewBox: '0 0 24 24' },
      e('path', { d: 'M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.84 3.44 8.87 8 9.8V15H8v-3h2V9.5C10 7.57 11.57 6 13.5 6H16v3h-2c-.55 0-1 .45-1 1v2h3v3h-3v6.95c4.56-.93 8-4.96 8-9.8z' })
    );
  }
  if (platform === 'instagram') {
    return e('svg', { className: 'w-4 h-4', viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round' },
      e('rect', { x: '2', y: '2', width: '20', height: '20', rx: '5', ry: '5' }),
      e('path', { d: 'M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z' }),
      e('line', { x1: '17.5', y1: '6.5', x2: '17.51', y2: '6.5' })
    );
  }
  if (platform === 'twitter') {
    return e('svg', { className: 'w-4 h-4 fill-current', viewBox: '0 0 24 24' },
      e('path', { d: 'M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z' })
    );
  }
  if (platform === 'linkedin') {
    return e('svg', { className: 'w-4 h-4 fill-current', viewBox: '0 0 24 24' },
      e('path', { d: 'M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 1 1 0-4.124 2.062 2.062 0 0 1 0 4.124zM7.114 20.452H3.558V9h3.556v11.452z' })
    );
  }
  return null;
}

export default function Footer() {
  return e('footer', { className: 'bg-[#1E2229] text-neutral-400 text-sm font-body pt-16 pb-8' },
    e('div', { className: 'max-w-7xl mx-auto px-6' },

      // Main Grid Links Layout
      e('div', { className: 'grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 pb-12' },

        // Column 1: Brand & Description
        e('div', { className: 'md:col-span-4 flex flex-col gap-5' },
          e(Link, { to: '/', className: 'flex items-center group w-fit' },
            e('img', { src: logo, alt: 'Rent Gurus', className: 'h-11 w-auto object-contain transition-transform group-hover:scale-105' })
          ),
          e('p', { className: 'text-neutral-400 leading-relaxed max-w-sm' },
            'Rent Gurus compares top car rental brands worldwide so you get the best price, transparent deals, and total peace of mind on every trip.'
          ),
          e('div', { className: 'flex items-center gap-3 mt-2' },
            socialPlatforms.map(({ platform, href }) =>
              e('a', {
                key: platform,
                href: href,
                target: '_blank',
                rel: 'noopener noreferrer',
                className: 'w-9 h-9 rounded-full border border-neutral-700 flex items-center justify-center text-neutral-400 hover:text-white hover:border-neutral-500 transition-colors'
              },
                e(SocialIcon, { platform: platform })
              )
            )
          )
        ),

        // Column 2: Quick Links
        e('div', { className: 'md:col-span-2 md:pl-4 flex flex-col gap-4' },
          e('h4', { className: 'text-white font-bold tracking-wider text-[13px] uppercase' }, 'Quick Links'),
          e('div', { className: 'flex flex-col gap-3 font-medium text-neutral-300' },
            e(Link, { to: '/manage-booking', className: 'hover:text-white transition-colors' }, 'Manage Booking'),
            e(Link, { to: '/support', className: 'hover:text-white transition-colors' }, 'Support'),
            e(Link, { to: '/about-us', className: 'hover:text-white transition-colors' }, 'About Us'),
            e(Link, { to: '/policy', className: 'hover:text-white transition-colors' }, 'Privacy Policy')
          )
        ),

        // Column 3: Popular Locations
        e('div', { className: 'md:col-span-3 flex flex-col gap-4' },
          e('h4', { className: 'text-white font-bold tracking-wider text-[13px] uppercase' }, 'Popular Locations'),
          e('div', { className: 'flex flex-col gap-3 font-medium text-neutral-300' },
            e('p', { className: 'hover:text-white transition-colors' }, 'Toronto'),
            e('p', { className: 'hover:text-white transition-colors' }, 'Vancouver'),
            e('p', { className: 'hover:text-white transition-colors' }, 'Los Angeles'),
            e('p', { className: 'hover:text-white transition-colors' }, 'Miami'),
            e('p', { className: 'hover:text-white transition-colors' }, 'New York')
          )
        ),

        // Column 4: Support & Details
        e('div', { className: 'md:col-span-3 flex flex-col gap-4' },
          e('h4', { className: 'text-white font-bold tracking-wider text-[13px] uppercase' }, 'Support'),
          e('div', { className: 'flex flex-col gap-3.5 text-neutral-300 font-medium' },
            // Phone
            e('a', { href: 'tel:+18889573332', className: 'flex items-center gap-3 hover:text-white transition-colors group' },
              e('svg', { className: 'w-4 h-4 text-[#22C55E] pointer-events-none', fill: 'none', stroke: 'currentColor', strokeWidth: '2', viewBox: '0 0 24 24' },
                e('path', { d: 'M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z' })
              ),
              '+1 (888) 957-3332'
            ),
            // Email
            e('a', { href: 'mailto:support@rentgurus.com', className: 'flex items-center gap-3 hover:text-white transition-colors group' },
              e('svg', { className: 'w-4 h-4 text-[#22C55E] pointer-events-none', fill: 'none', stroke: 'currentColor', strokeWidth: '2', viewBox: '0 0 24 24' },
                e('path', { strokeLinecap: 'round', strokeLinejoin: 'round', d: 'M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75' })
              ),
              'support@rentgurus.com'
            )
          )
        )
      ),

      // Bottom Bar Divider
      e('div', { className: 'border-t border-neutral-800 my-4' }),

      // Sub-Footer
      e('div', { className: 'flex flex-col sm:flex-row items-center justify-between gap-4 pt-4 text-xs text-neutral-500 font-medium' },
        e('div', null, '\u00A9 2026 Rent Gurus. All rights reserved.'),
        e('div', { className: 'flex items-center gap-6' },
          e(Link, { to: '/policy', className: 'hover:text-neutral-300 transition-colors' }, 'Privacy'),
          e(Link, { to: '/terms-and-conditions', className: 'hover:text-neutral-300 transition-colors' }, 'Terms'),
          e(Link, { to: '/cookies', className: 'hover:text-neutral-300 transition-colors' }, 'Cookies')
        )
      )
    )
  );
}